
import {UIGameSpecialBuildPhaseButtonController} from '../../../../shared/scripts/ui_game/ui_game_special_build_phase/UIGameSpecialBuildPhaseButtonController'
import {SpriteButtonView} from '../../../../shared/scripts/ui_canvas_engine/SpriteButtonView'

export class UIWGameSpecialBuildPhaseButtonController extends UIGameSpecialBuildPhaseButtonController {
    protected createButton() {
        const canvas = this.uiGameManager.canvasController
        const w = canvas.itemSize / 2
        const h = canvas.itemSize / 2
        const x = canvas.appW - canvas.chatWidth - canvas.itemSize * 5 + w
        const y = canvas.appH - canvas.itemSize * 2 + w

        this.button = new SpriteButtonView(x, y, w, h, canvas.app.stage)
        super.createButton()
    }
}
